import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../utils/EventBus";
import financeService from "../services/finance.service";

export const createfinancier = createAsyncThunk(
  "api/createfinancier",
  async (stateData, thunkAPI) => {
    try {
      const data = await financeService.createFinancier(stateData);
      return { statedata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getfinancier = createAsyncThunk(
  "api/getfinancier",
  async (thunkAPI) => {
    try {
      const data = await financeService.getFinancier();
      return { statedata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatefinanccier = createAsyncThunk(
  "api/updatefinanccier",
  async ({c_id, formData}, thunkAPI) => {
    try {
      const data = await financeService.updateFinancier(c_id, formData);
      return { statedata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deletefinancier = createAsyncThunk(
  "api/deletefinancier",
  async ({c_id}, thunkAPI) => {
    try {
      const data = await financeService.deleteFinancier(c_id);
      return { statedata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    financier:[]
}

const financeSlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [createfinancier.fulfilled]: (state, action) => {
      state.financier.push(action.payload.statedata.data)
    return state;
    },
    [getfinancier.fulfilled]: (state, action) => {
      state.financier = action.payload.statedata.data
      return state;
    },
    [updatefinanccier.fulfilled]: (state, action) => {
      const {
        arg: { c_id },
      } = action.meta;
      if (c_id) {
        state.financier = state.financier.map((item) =>
          item.finance_id === c_id ? action.payload.statedata.data : item
        );
      };
      state.message = "Update User Successfully"
    },
    [deletefinancier.fulfilled]: (state, action) => {
      const {
        arg: { c_id },
      } = action.meta;
      if (c_id) {
        state.finance_id = state.financier.filter((item) => item.finance_id !== c_id);
      };
      state.message = action.payload.statedata.message
    },
  },
});

const { reducer } = financeSlice;
export default reducer;